/* Update cart items */
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.cart = this;
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );

      this.catchQuantityChange();

      // Create bound handlers
      this.completeLookHandler = (event) => {
        let variantId = event.target.value;
        let type = event.target.dataset.upsellType;
        if (variantId) {
          this.addUpsell(variantId, type);
        }
      };

      this.addToCartHandler = (event) => {
        let variantId = event.target.dataset.variantId;
        let type = event.target.dataset.upsellType;
        if (variantId) {
          this.addUpsell(variantId, type);
        }
      };
    }

    connectedCallback() {
      this.bindCompleteLookTriggers();
    }

    bindCompleteLookTriggers() {
      // Hack: forcibly remove all existing listeners by cloning, modeled after main-product.js approach
      // Clone elements to remove all previous event listeners
      let completeLookTriggers = document.querySelectorAll('[data-quickshop]');
      let addToCartTriggers = document.querySelectorAll('[data-quickshop-add-to-cart]');

      completeLookTriggers.forEach((trigger) => {
        const clonedTrigger = trigger.cloneNode(true);
        trigger.replaceWith(clonedTrigger);
      });

      addToCartTriggers.forEach((trigger) => {
        const clonedTrigger = trigger.cloneNode(true);
        trigger.replaceWith(clonedTrigger);
      });

      // Get fresh references to the cloned elements
      let freshCompleteLookTriggers = document.querySelectorAll('[data-quickshop]');
      let freshAddToCartTriggers = document.querySelectorAll('[data-quickshop-add-to-cart]');

      // Add new listeners to cloned elements
      freshCompleteLookTriggers.forEach((trigger) => {
        trigger.addEventListener('change', this.completeLookHandler);
      });

      freshAddToCartTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.addToCartHandler);
      });
    }

    addUpsell(variantId, type = null) {
      let cartDrawer = document.querySelector('cart-drawer');
      cartDrawer.addUpsell(variantId, type);
    }

    catchQuantityChange() {
      this.quantityInputArr = document.querySelectorAll('[data-quantity]');
      this.debouncedOnChange = debounce((event) => {
        if (event.target != document.getElementById('Cart-note')) {
          this.onChange(event);
        }
      }, 300);
      if (this.quantityInputArr) {
        let that = this;
        this.quantityInputArr.forEach((quantityInput) => {
          quantityInput.addEventListener('change', that.debouncedOnChange.bind(this));
        });
      }
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        event.target.dataset.key,
        document.activeElement.getAttribute('name'),
        event
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-header',
          section: document.getElementById('main-cart-header').dataset.id,
          selector: '.cart-drawer__header-wrapper',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'cart-upsells',
          section: document.getElementById('cart-upsells').dataset.id,
          selector: '.js-cart-upsells',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    /**
     * updateQuantity
     * @description Works together with the Ajax Cart API.
     * @see https://shopify.dev/docs/api/ajax/reference/cart
     * @param {Number} line
     * @param {Number} quantity
     * @param {String} name
     * @param {Object} event
     */
    async updateQuantity(line, quantity, key, name, event) {
      this.enableLoading(line);

      // Create addon items in one loop
      const addOnUpdates = {};
      document.querySelectorAll(`[data-parent-key="${key}"]`).forEach((item) => {
        const addOnKey = item.dataset.key;
        const parentMultiplier = item.dataset.parentMultiplier || 1;
        addOnUpdates[addOnKey] = quantity * parseInt(parentMultiplier);
      });

      // Clear upsell attributes
      const attributes = {};
      const upsellType = event.target.dataset?.upsellType || '';
      if (upsellType.includes('question') && quantity == 0) {
        const attributeName = upsellType.split('||')[1];
        if (attributeName) {
          attributes[attributeName] = 'skipped';
        }
      } else if (upsellType.includes('upsell-') && quantity == 0) {
        const attributeName = upsellType;
        attributes[attributeName] = '';
      }

      // Update Cart items
      const body = JSON.stringify({
        id: key,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      try {

        // Update the add ons
        if (Object.keys(addOnUpdates).length > 0) {
          await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ updates: addOnUpdates }),
          });
        }

        // Update the attributes
        if (Object.keys(attributes).length > 0) {
          await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ attributes: attributes }),
          });
        }

        // Update the main item (update after the add ons to get the correct section html)
        const response = await fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body,
        });
        const parsedState = await response.json();

        this.classList.toggle('cart-is-empty', parsedState.item_count === 0);

        // Error returned in request
        if (response.status === 422 && parsedState.errors) {
          // Read current updated quantity element
          const itemQuantityInput = document.getElementById(`Quantity-${line}`);
          const currentValue = itemQuantityInput.value;
          const maxValue = itemQuantityInput.dataset.max;
          // Reset input value quantity
          if (currentValue > maxValue) itemQuantityInput.value = maxValue;
          // Show the error message to the users
          throw new Error(parsedState.errors);
        }

        // Tell the user that something is wrong when there are no sections returned from the call.
        if (!parsedState.sections) {
          event.target.value = event.target.defaultValue;
          throw new Error(window.cartStrings.error);
        }

        // Loop sections
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.bindCompleteLookTriggers();

        this.updateLiveRegions(line, parsedState.item_count);

        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.cartDrawer = document.querySelector('cart-drawer');
        this.catchQuantityChange();
        if (this.cartDrawer) {
          this.cartDrawer.applyDiscounts();
        } else {
          this.disableLoading();
        }
      } catch (error) {
        document.querySelectorAll('[data-cart-loader-active="show"]').forEach((loaderIcon) => {
          loaderIcon?.classList.add('hidden');
        });
        document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((loaderIcon) => {
          loaderIcon?.classList.remove('hidden');
        });
        document.getElementById('cart-errors').textContent = error
          ? error
          : window.cartStrings.error;
        this.disableLoading();
      }
    }

    // show error texts, should not be deleted.
    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text').innerHTML =
          window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      //document.querySelector('cart-items').classList.add('cart-items-is-loading');
      document.querySelectorAll('[data-cart-loader-active="show"]').forEach((loaderIcon) => {
        loaderIcon?.classList.remove('hidden');
      });
      document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((loaderIcon) => {
        loaderIcon?.classList.add('hidden');
      });
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      //document.querySelector('cart-items').classList.remove('cart-items-is-loading');
      document.querySelectorAll('[data-cart-loader-active="show"]').forEach((loaderIcon) => {
        loaderIcon?.classList.add('hidden');
      });
      document.querySelectorAll('[data-cart-loader-active="hidden"]').forEach((loaderIcon) => {
        loaderIcon?.classList.remove('hidden');
      });
    }
  }

  customElements.define('cart-items', CartItems);
}

/* Remove item from the cart  */
if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      });
    }
  }
  customElements.define('cart-remove-button', CartRemoveButton);
}

/* Update the cart note */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);
}
